// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AddCategoryModal_overlay__t2YzP {
  position: fixed;
  top: 0; left: 0;
  width: 100vw; height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
}

.AddCategoryModal_modal__h65LY {
  background: white;
  padding: 20px;
  border-radius: 10px;
  width: 400px;
}

.AddCategoryModal_header__NyotA {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  font-weight: bold;
}

.AddCategoryModal_close__dM72w {
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
}

.AddCategoryModal_form__t\\+ba9 label {
  display: block;
  margin-bottom: 5px;
  font-weight: 500;
}

.AddCategoryModal_select__m0LUg, .AddCategoryModal_input__tvfbG {
  width: 100%;
  padding: 10px;
  margin-bottom: 20px;
  border-radius: 8px;
  border: 1px solid #ccc;
}

.AddCategoryModal_required__qyXO9 {
  color: red;
}

.AddCategoryModal_saveBtn__8sLZi {
  position: relative;
  padding: 10.5px 20px;
  background-color: rgba(29, 135, 82, 1);
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/tables/AddCategoryModal.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM,EAAE,OAAO;EACf,YAAY,EAAE,aAAa;EAC3B,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,sCAAsC;EACtC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB","sourcesContent":[".overlay {\n  position: fixed;\n  top: 0; left: 0;\n  width: 100vw; height: 100vh;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10;\n}\n\n.modal {\n  background: white;\n  padding: 20px;\n  border-radius: 10px;\n  width: 400px;\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 20px;\n  font-weight: bold;\n}\n\n.close {\n  background: none;\n  border: none;\n  font-size: 20px;\n  cursor: pointer;\n}\n\n.form label {\n  display: block;\n  margin-bottom: 5px;\n  font-weight: 500;\n}\n\n.select, .input {\n  width: 100%;\n  padding: 10px;\n  margin-bottom: 20px;\n  border-radius: 8px;\n  border: 1px solid #ccc;\n}\n\n.required {\n  color: red;\n}\n\n.saveBtn {\n  position: relative;\n  padding: 10.5px 20px;\n  background-color: rgba(29, 135, 82, 1);\n  color: white;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `AddCategoryModal_overlay__t2YzP`,
	"modal": `AddCategoryModal_modal__h65LY`,
	"header": `AddCategoryModal_header__NyotA`,
	"close": `AddCategoryModal_close__dM72w`,
	"form": `AddCategoryModal_form__t+ba9`,
	"select": `AddCategoryModal_select__m0LUg`,
	"input": `AddCategoryModal_input__tvfbG`,
	"required": `AddCategoryModal_required__qyXO9`,
	"saveBtn": `AddCategoryModal_saveBtn__8sLZi`
};
export default ___CSS_LOADER_EXPORT___;
